// src/components/Indices.jsx
import React, { useEffect } from 'react';
import '../styles/Indices.css';
import recurso1 from '../assets/icons/Recurso 5.png';
import recurso2 from '../assets/icons/Recurso 2.png';
import recurso3 from '../assets/icons/Recurso 3.png';
import recurso4 from '../assets/icons/Recurso 4.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Indices() {
  useEffect(() => {
    const onLoad = () => {
      console.log('Inicializando AOS después de load…');
      AOS.init({
        duration: 800,
        once: true,
        easing: 'ease-out',
        offset: 0, // dispara apenas entra al viewport
      });
      AOS.refreshHard();
    };

    if (document.readyState === 'complete') onLoad();
    else window.addEventListener('load', onLoad);

    return () => window.removeEventListener('load', onLoad);
  }, []);

  return (
    <section className="indices" id="indices">
      <div className="indices-overlay">
         <div className="indices-body">
        <div className="indices-left">
          <h2 className="indices-title">Confianza cultivada<br />con experiencia.</h2>   
            <p>
              Desde 2018 producimos fertilizantes convencionales y orgánicos que mejoran el rendimiento y la salud de los cultivos. Durante años hemos sido aliados de grandes empresas del sector agrícola, ofreciendo insumos de calidad y asesoría técnica especializada.<br />
              Hoy damos un paso más: llegamos directamente a ti, a través de puntos de venta y canales online, para que puedas acceder a productos efectivos, rentables y de confianza.<br />
              Nuestra propuesta es simple: más resultados, mejor relación costo–beneficio y mayores márgenes para distribuidores y consumidores. Todo gracias a nuestras economías de escala, que nos permiten ofrecer una verdadera solución gana-gana para el campo.<br />
            </p>
         </div>
          <div className="indices-right">
            <div
              className="indice-card escalon-1"
              data-aos="fade-up"
              data-aos-delay="0"
              data-aos-anchor-placement="top-bottom"
            >
              <img src={recurso1} alt="Absorción" id="icon35"/>
              <div>
                <p>Mas de 35 años de experiencia en el sector agrícola</p>
              </div>
            </div>

            <div
              className="indice-card escalon-2"
              data-aos="fade-up"
              data-aos-delay="120"
              data-aos-anchor-placement="top-bottom"
            >
              <img src={recurso2} alt="Crecimiento" />
              <div>
                <h4>Somos una empresa legalmente constituida y direccionada bajo lineamientos del Instituto Colombiano de Agricultura.</h4>
              </div>
            </div>

            <div
              className="indice-card escalon-3"
              data-aos="fade-up"
              data-aos-delay="240"
              data-aos-anchor-placement="top-bottom"
            >
              <img src={recurso3} alt="Resistencia" />
              <div>
                <h4>Desarrollamos planes de manejo y fertilizantes que han impactado a la industria azucarera, frutícola y al sector cafetero con producciones para el mercado internacional.</h4>
              </div>
            </div>
            <div
              className="indice-card escalon-4"
              data-aos="fade-up"
              data-aos-delay="240"
              data-aos-anchor-placement="top-bottom"
            >
              <img src={recurso4} alt="Resistencia" />
              <div>
                <h4>Aliados de empresas multinacionales que buscan la implementación de la agricultura regenerativa en la región.</h4>
              </div>
            </div>
          </div>       
         </div>
        <p className="final-line"
           data-aos="fade-up" 
           data-aos-duration="1000"
        >
          Hoy, damos el siguiente paso: llegar al consumidor final, con canales físicos y ventas online que nos acercan más al campo colombiano.
        </p>
      </div>
    </section>
  );
}

export default Indices;
